// Liens des emails : ?codes=VIPNID,VIPLAMES applique tous les codes, ?add=<variante>:<qté>,... ajoute des produits.
// Un lien /discount/A,B ne marche pas : Shopify le lit comme un seul code.
(function () {
  var params = new URLSearchParams(window.location.search);
  var codes = (params.get('codes') || '').split(',').map(function (c) { return c.trim(); }).filter(Boolean);
  var items = (params.get('add') || '').split(',').map(function (pair) {
    var p = pair.split(':');
    return { id: Number(p[0]), quantity: Number(p[1] || 1) };
  }).filter(function (it) { return it.id > 0 && it.quantity > 0; });
  if (!codes.length && !items.length) return;

  params.delete('codes');
  params.delete('add');
  var query = params.toString();
  history.replaceState(history.state, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);

  function run() {
    var added = items.length
      ? fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: items })
        })
      : Promise.resolve();
    added
      .then(function () { return MGMFunnel.addDiscountCodes(codes); })
      .then(function () {
        document.dispatchEvent(new CustomEvent('mgm:codes-applied', { detail: { codes: codes } }));
        if (window.location.pathname === '/cart') return window.location.reload();
        var drawer = window.MGMCartDrawer;
        if (!drawer) return;
        if (items.length) drawer.open(drawer.STATE.CART);
        else drawer.refresh();
      })
      .catch(function (e) {
        console.warn('[MGM] codes URL', e);
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
